import { CanActivateFn, Router } from '@angular/router';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { AlertModalComponent } from '../shared/modals/alert-modal/alert-modal.component';
import { inject } from '@angular/core';
import { ClientBrowserSessionStorageService } from '../services/client-browser-session-storage.service';
import { Commons } from '../shared/Commons';

export const flowQuotesGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const modalService = inject(MdbModalService);
  const sessionStorageService = inject(ClientBrowserSessionStorageService);

  if (Commons.sessionIsOpen(sessionStorageService)) {
    const sessionRol = Commons.customerRol(sessionStorageService)
    const sessionRolByFlow = Commons.sessionRolByFlow(sessionStorageService, Commons.FLOW_QUOTES);
    const authMainRol = sessionRol === Commons.USER_ROL_RW || sessionRol === Commons.USER_ROL_RWX;
    const authSecondaryRol = sessionRolByFlow === Commons.USER_ROL_RW || sessionRolByFlow === Commons.USER_ROL_RWX;
    const authorized = authMainRol || authSecondaryRol;
    const authorizedFlow = sessionRolByFlow !== Commons.USER_ROL_LOCK

    if (!authorized || !authorizedFlow) {
      openModal(modalService, 'validations.not-allowed', 'validations.customer-not-allowed', Commons.ICON_WARNING);
      router.navigate([Commons.PATH_MAIN]);
      return false;
    } else {
      return true;
    }
  }

  return false;
};

function openModal(modalService: MdbModalService, title: string, message: string, icon: string) {
  modalService.open(AlertModalComponent, {
    data: { title: title, message: message, icon: icon },
  });
}
